// Two-unit countdown formatter for tournament cards and menu widgets.
//
// The spec asks for "the two most relevant units": when days are left,
// show only days + hours; when only hours, show hours + minutes; when
// only minutes, show minutes + seconds. The lower unit is dropped when
// it would be "0" in the obvious cases — "2d 0h" reads like a glitch,
// so we just say "2d" then.

export function formatCountdown(targetMs: number, nowMs: number = Date.now()): string {
  const remaining = Math.max(0, targetMs - nowMs);
  if (remaining === 0) return 'Ended';

  const totalSec = Math.floor(remaining / 1000);
  const days = Math.floor(totalSec / 86_400);
  const hours = Math.floor((totalSec % 86_400) / 3_600);
  const minutes = Math.floor((totalSec % 3_600) / 60);
  const seconds = totalSec % 60;

  if (days > 0) {
    return hours > 0 ? `${days}d ${hours}h` : `${days}d`;
  }
  if (hours > 0) {
    return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
  }
  if (minutes > 0) {
    return seconds > 0 ? `${minutes}m ${seconds}s` : `${minutes}m`;
  }
  return `${seconds}s`;
}

/** Like formatCountdown but always shows two units, padding with zero
 *  when the lower unit is 0. Used in places where layout stability
 *  matters (e.g. the menu widget where the line shouldn't reflow). */
export function formatCountdownPadded(targetMs: number, nowMs: number = Date.now()): string {
  const remaining = Math.max(0, targetMs - nowMs);
  if (remaining === 0) return 'Ended';

  const totalSec = Math.floor(remaining / 1000);
  const days = Math.floor(totalSec / 86_400);
  const hours = Math.floor((totalSec % 86_400) / 3_600);
  const minutes = Math.floor((totalSec % 3_600) / 60);
  const seconds = totalSec % 60;

  if (days > 0) return `${days}d ${hours}h`;
  if (hours > 0) return `${hours}h ${minutes}m`;
  return `${minutes}m ${seconds}s`;
}
